import { useSession } from '@hooks/security/use-session';
import { useScreeningComplete } from '@hooks/register/screening/use-screening-complete';
import { useLocalize } from '@hooks/use-localize';
import { DashRegistrationStep } from '@/types/dashboard';
import PageLoader from '@components/page-loader';
import ScreeningProgress from '@views/register/screening/screening-progress';
import ScreeningResults from './screening-results';

const ScreeningComplete = () => {
    const { registrationId, editKey } = useSession();
    const { completeModel, resultsModel, isLoading, error } = useScreeningComplete(registrationId, editKey);
    const t = useLocalize(completeModel.languageData);

    return (
        <PageLoader isLoading={isLoading} error={error}>
            <div className="row">
                <div className="col-xs-12 col-sm-3 hidden-xs">
                    <ScreeningProgress
                        model={completeModel}
                        overrideStep={DashRegistrationStep.ScreeningComplete}
                    />
                </div>

                <div className="col-xs-12 col-sm-6 summary-mobile-content middle-content">
                    {resultsModel == null ?
                        <>
                            <h1>{t('DashLabel_ThankYou', 'ThankYou')}!</h1>

                            <h4>
                                {t(
                                    'DashLabel_ThankYouForCompletingTheseScreeningQuestions',
                                    'Thank you for completing these screening questions. We will send you an e-mail with the results of the screening in 1 business day',
                                )}
                                .
                            </h4>
                        </>
                        :
                        <ScreeningResults model={resultsModel} />
                    }
                </div>
            </div>
        </PageLoader>
    );
};

export default ScreeningComplete;
